import { NgModule }           from '@angular/core';
// Modules
import { NxNavigationModule } from '../common/components/nx-navigation/nx-navigation.module';
// Models
import { NxMenuItems }        from '../common/components/nx-navigation/nx-menu-item';
import { BaseRoles }          from '../common/models';

const menu: NxMenuItems = [{ 
  name      : 'covidInfo', 
  label     : 'covid.navigation.info', 
  icon      : 'mdi mdi-information', 
  role      : [BaseRoles.SUPER_ADMIN, BaseRoles.ADMIN, BaseRoles.GUEST],
  items     : [],
  routerLink: '/covidInfo'
}];

@NgModule({
  imports  : [ NxNavigationModule.forChild(menu) ],
  exports  : [ NxNavigationModule ],
  providers: []
})
export class InfoNavigationModule { }